import { useState, FormEvent, useEffect, useContext, DragEvent } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { lisatarLeads, atualizarLead, deletarLead } from '../../services/leads'
import { listaLeadsRespostaPayload } from '../../interfaces/leads'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { toast } from 'react-toastify'
import { usuariosRespostaPayload } from '../../interfaces/usuarios'
import { listarUsuariosOrganizacao } from '../../services/usuarios'
import { Button, Loader } from '../Styles'
import { descriptografarDado } from '../../helpers'
import ModulosContratados from '../../middleware/SistemasContratados'
import ModalLeads from '../ModalLeads'
import ModalCadstro from '../ModalCadastros'
import ModalProcessos from '../ModalProcessos'
import FiltrosDefault from '../FiltrosDefault'
import apagarImg from '../../assets/img/excluir.png'
import LoagindBarra from '../LoadingBarra'
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato'
import Permissoes from '../../middleware/Permissoes'
import maisFiltrosImg from '../../assets/img/maisFiltros.png'
import avatarDefault from '../../assets/img/avatarDefault.png'
import '../../styles/paginaListaDados.css'
import './leads.css'

function Leads () {

    const { atualizarDados, atualizarInformacoes, modal, modalExibir } = useContext(ModalEstadoContext)

    const navigate = useNavigate()
    const location = useLocation ()
    const { pathname } = location

    const usuarioLogado = localStorage.getItem('usuarioGesttor')

    const [leads, setLeads] = useState<listaLeadsRespostaPayload[]>([])
    const [leadSelecionado, setLeadSelecionado] = useState<listaLeadsRespostaPayload>()
    const [termo, setTermo] = useState('')
    const [situacao, setSituacao] = useState('')
    const [processando, setProcessando] = useState(true)
    const [nenhumResultado, setNenhumResultado] = useState(false)
    const [responsavelFiltro, setResponsavelFiltro] = useState(usuarioLogado);
    const [maisFiltros, setMaisFiltros] = useState<boolean>(false)
    const [responsaveis, setResponsaveis] = useState<usuariosRespostaPayload[]>([])

    const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
    const permissoesFiltrosAvancados = ['master', 'lead_filtro_avancado']
    const temPermissao = permissoesArray.some((permissao: string) => permissoesFiltrosAvancados.includes(permissao))

    const exibirModalNovoLead = () => modalExibir('lead')

    const exibirModalDadosLead = (idLead: string, lead: listaLeadsRespostaPayload) => {

        modalExibir('lead')
        navigate(`${pathname}?idLead=${idLead}`)

        return setLeadSelecionado(lead)
    }

    const dragStartLead = (e: DragEvent<HTMLTableRowElement>, lead: listaLeadsRespostaPayload) => {

        const leadString = JSON.stringify(lead)

        e.dataTransfer.setData('lead', leadString)
    }

    const dropLead = async (e: React.DragEvent<HTMLSpanElement>, situacao: string) => {
        e.preventDefault()

        const leadTransfer = e.dataTransfer.getData('lead')
        const leadArrastado = JSON.parse(leadTransfer)

        if (leadArrastado.situacao === 'Novo' || leadArrastado.idResponsavel === null) {
            const leadParaModal = { ...leadArrastado, situacao }
            exibirModalDadosLead(leadParaModal.id, leadParaModal)
            return
        }

        setProcessando(true)
        const { id, nome, telefone, email, mensagem, empresa, formaConhecimento, resultado } = leadArrastado
        try {

            const payload = {
                nome,
                telefone,
                empresa,
                email,
                mensagem,
                formaConhecimento,
                resultado,
                situacao
            }

            const resposta = await atualizarLead(id, payload)

            if(resposta.status === 200) {
                setProcessando(false)
                atualizarDados()
            }

            return
            
        } catch {
            setProcessando(false)

            return toast.error('Ocorreu um Erro ao Atualizar os Dados')
            
        }

    }

    const dragOverLead = (e: DragEvent<HTMLSpanElement>) => {
        e.preventDefault()
    }

    const filtrarLeads = async (e: FormEvent) => {
        
        e.preventDefault()
        setNenhumResultado(false)
        setProcessando(true)

        try {

            const params = {
                nome: termo,
                situacao: situacao,
                idResponsavel: responsavelFiltro
            }

            const resposta = await lisatarLeads(params)

            if (resposta.data.length === 0) {
                setLeads(resposta.data)
                setProcessando(false)
                return setNenhumResultado(true)
            }

            if(resposta.status === 200) {
                setLeads(resposta.data)
                setProcessando(false)

                return
            }
            
        } catch {

            setProcessando(false)
            toast.error("Erro ao filtrar Lead.")
            
            return
        } finally {
            setMaisFiltros(false)
        }

    }

    useEffect (() => {

        if(!modal.nome) setLeadSelecionado(undefined)

    }, [modal])


    const apagarLead = async (idLead: string) => {

        setProcessando(true)

        try {

            const resposta = await deletarLead(idLead)

            if(resposta.status === 200) {
                setProcessando(false)
                atualizarDados()
                toast.success("Lead deletado com sucesso.")
            }
            
        } catch {

            setProcessando(false)
            return toast.error("Erro ao deletar Lead.")
        }
    }

    useEffect(() => {

        const buscarLeads = async () => {

            setNenhumResultado(false)
            setProcessando(true)

            try {

                const params = {
                    nome: '',
                    situacao: '',
                    idResponsavel: responsavelFiltro
                }

                const resposta = await lisatarLeads(params)

                if (resposta.data.length === 0) {
                    setLeads(resposta.data)
                    setProcessando(false)
                    return setNenhumResultado(true)
                }

                if(resposta.status === 200) {
                    setLeads(resposta.data)
                    setProcessando(false)

                    return
                }
                
            } catch {

                setProcessando(false)
                
                return toast.error("Erro ao buscar Leads.")
            }
        }

        buscarLeads()

    }, [atualizarInformacoes])

    useEffect(() => {
        
        const buscarResponsaveis = async () => {

            try {

                const params = {
                    termo: '',
                    situacao: 'ativo'
                }

                const resposta = await listarUsuariosOrganizacao(params)

                if (resposta.status === 200) {
                    return setResponsaveis(resposta.data)
                }
                
            } catch {
                return toast.error('Falha ao Listar os Responsáveis')
            }
        }

        buscarResponsaveis ()

    }, [])

    return (
        <ModulosContratados modulo={["Atendimento"]}>
            <Permissoes permissoes={['master', 'administrativo', 'atendimento', 'atendimento_lead']}>
                <div id='paginaContainer'>
                    {modal.nome === 'lead' && <ModalLeads lead={leadSelecionado} />}
                    {modal.nome === 'cadastro' && <ModalCadstro/>}
                    {modal.nome === 'processo' && <ModalProcessos/>}
                    {processando && <LoagindBarra />}
                    {nenhumResultado && <NenhumResultadoEncontrado />}
                    <FiltrosDefault placeholder='Pesquise pelo nome do lead' termo={termo} situacao={situacao} onChangeTermo={(e) => setTermo(e.target.value)} tipo='lead' onChangeSituacao={(e) => setSituacao(e.target.value)} listaSituacao={[{nome: 'Todos', valor: ''}, {nome: 'Sem Contato', valor: 'Novo'}, {nome: 'Em Negociação', valor: 'Em Negociação'}, {nome: 'Conquistado', valor: 'Conquistado'}, {nome: 'Perdido', valor: 'Perdido'}]} onSubmit={filtrarLeads} acaoBtn={exibirModalNovoLead} genero='masculino' isLoading={processando} maisFiltros={temPermissao ? true : false} acaoMaisFiltro={()=>setMaisFiltros(true)}/>
                    {maisFiltros && temPermissao && <section className='maisOpcoesFiltrosComponente'>
                    <form className='maisOpcoesFiltros' onSubmit={filtrarLeads}>
                        <span className='filtrosContainerTitulo'>
                            <img className='filtrosAvancados' src={maisFiltrosImg} alt='' />
                            <p>Filtros Avançados</p>
                        </span>
                        <section className='opcoesFiltros'>
                            <section>
                                <span>
                                    <label htmlFor="">Responsável</label>
                                    <select value={responsavelFiltro ?? ""} onChange={(e) => setResponsavelFiltro(e.target.value)}>
                                        <option value="">Todos</option>
                                        {responsaveis.map((responsavel) => (<option value={responsavel.id}>{responsavel.nome}</option>))}
                                    </select>
                                </span>
                                <span>
                                    <label htmlFor="">Situação</label>
                                    <select value={situacao} onChange={(e) => setSituacao(e.target.value)}>
                                        <option value="">Todos</option>
                                        <option value="Em Negociação">Em Negociação</option>
                                        <option value="Conquistado">Conquistado</option>
                                        <option value="Perdido">Perdido</option>
                                    </select>
                                </span>
                            </section>
                            <section>
                                <span>
                                    <label htmlFor="">Lead</label>
                                    <input
                                        value={termo}
                                        onChange={(e) => setTermo(e.target.value)}
                                        placeholder='Pesquise pelo nome do lead'
                                    />
                                </span>
                            </section>
                        </section>
                        <span id="botoesContainerFiltrosTarefas">
                            <Button type='reset' cor='cancelar' isLoading={processando} onClick={() => setMaisFiltros(false)}>Cancelar</Button>
                            <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                {!processando && 'Buscar Dados'}
                                {processando && <Loader isLoading={processando} />}
                            </Button>
                        </span>
                    </form>
                </section>}

                    <section id='fundoContainerPagina'>
                        <section id='leadsContainer'>
                            <span onDrop={(e) => dropLead(e, 'Novo')} onDragOver={dragOverLead}>
                                <h1>Novo</h1>
                                <section className='leadContainer'>
                                    <table id='tabelaListaContainer'>
                                        <thead>
                                            <tr>
                                                <th align='left' className='ladoEsquerdoContent'>Nome</th>
                                                <th id='telefoneLead' align='left'>Telefone</th>
                                                <th align='center'>Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leads.filter(lead => lead.idResponsavel === null).map((lead) => (
                                                <tr key={lead.id} draggable onDragStart={(e) => dragStartLead(e, lead)}>
                                                    <td className='primeiraColuna nomeLead' onClick={() => exibirModalDadosLead(lead.id, lead)}>{lead.nome}</td>
                                                    <td id='telefoneLead' onClick={() => exibirModalDadosLead(lead.id, lead)}>{lead.telefone}</td>
                                                    <td id='ladoDireitoContent' align='center'>
                                                        <Permissoes permissoes={['master']}>
                                                            <img id='apagarIconeLead' title='Excluir Lead' src={apagarImg} alt='' onClick={() => apagarLead(lead.id)}/>
                                                        </Permissoes>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </section>
                            </span>
                            <span onDrop={(e) => dropLead(e, 'Em Negociação')} onDragOver={dragOverLead}>
                                <h1>Em Negociação</h1>
                                <section className='leadContainer'>
                                    <table id='tabelaListaContainer'>
                                        <thead>
                                            <tr>
                                                <th align='left' className='ladoEsquerdoContent nomeLead'>Nome</th>
                                                <th id='telefoneLead' align='left'>Telefone</th>
                                                <th id='responsavel' align='left'>Responsável</th>
                                                <th align='center'>Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leads.filter(lead => lead.situacao === 'Em Negociação').map((lead) => (
                                                <tr key={lead.id} draggable onDragStart={(e) => dragStartLead(e, lead)}>
                                                    <td className='primeiraColuna' onClick={() => exibirModalDadosLead(lead.id, lead)}>{lead.nome}</td>
                                                    <td id='telefoneLead' onClick={() => exibirModalDadosLead(lead.id, lead)}>{lead.telefone}</td>
                                                    <td onClick={() => exibirModalDadosLead(lead.id, lead)}>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            {lead?.responsavel ? <img id='usuarioResponsavelAjuda' src={lead.responsavel.avatar || avatarDefault} alt='' /> : null}
                                                            {lead?.responsavel?.nome ?? ""}
                                                        </div>
                                                    </td>
                                                    <td id='ladoDireitoContent' align='center'>
                                                        <Permissoes permissoes={['master']}>
                                                            <img id='apagarIconeLead' title='Excluir Lead' src={apagarImg} alt='' onClick={() => apagarLead(lead.id)}/>
                                                        </Permissoes>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </section>
                            </span>
                            <span onDrop={(e) => dropLead(e, 'Conquistado')} onDragOver={dragOverLead}>
                                <h1>Conquistado/Perdido</h1>
                                <section className='leadContainer'>
                                    <table id='tabelaListaContainer'>
                                        <thead>
                                            <tr>
                                                <th align='left' className='ladoEsquerdoContent nomeLead'>Nome</th>
                                                <th id='telefoneLead' align='left'>Telefone</th>
                                                <th id='responsavel' align='left'>Responsável</th>
                                                <th align='center'>Ação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {leads.filter(lead => lead.situacao === 'Conquistado' || lead.situacao === 'Perdido').map((lead) => (
                                                <tr key={lead.id} className = {`lead${lead.situacao}`} draggable onDragStart={(e) => dragStartLead(e, lead)}>
                                                    <td className='primeiraColuna' onClick={() => exibirModalDadosLead(lead.id, lead)}>{lead.nome}</td>
                                                    <td id='telefoneLead' onClick={() => exibirModalDadosLead(lead.id, lead)}>{lead.telefone}</td>
                                                    <td onClick={() => exibirModalDadosLead(lead.id, lead)}>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            {lead?.responsavel ? <img id='usuarioResponsavelAjuda' src={lead.responsavel.avatar || avatarDefault} alt='' /> : null}
                                                            {lead?.responsavel?.nome ?? ""}
                                                        </div>
                                                    </td>
                                                    <td id='ladoDireitoContent' align='center'>
                                                        <Permissoes permissoes={['master']}>
                                                            <img id='apagarIconeLead' title='Excluir Lead' src={apagarImg} alt='' onClick={() => apagarLead(lead.id)}/>
                                                        </Permissoes>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </section>
                            </span>
                        </section>
                    </section>
                </div>
            </Permissoes>
        </ModulosContratados>
    )
}

export default Leads